module.exports = __webpack_public_path__ + "static/media/menu.798aa08b.png";